import { BASE_URL } from "../../data/BaseUrl";

export const fetchAllDraftPlans = async (filters, TOKEN) => {
  let url = `plan/draft/all?is_goal=0`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `&${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allDrafPlans = {
      data: responseJson?.data || [],
      pagination: responseJson?.pagination || [],
      dropdown: responseJson?.data?.map((item) => {
        const highestPlanPrice = Math.max(
          ...(item?.price_details?.map((detail) => detail?.plan_price) || [0])
        );

        return {
          value: item?.uid || "",
          label: item?.plan_name || "",
          price: highestPlanPrice || 0,
          pagination: responseJson?.pagination,
          info: item || {},
        };
      }),
    };

    return allDrafPlans;
  } catch (error) {
    console.error("fetchAllDraftPlans=> ", error);
    throw error;
  }
};

export const fetchOngoingOffers = async (filters, TOKEN) => {
  let url = `ongoing_offer/`;

  const filteredParams = Object.entries(filters || {})
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchOngoingOffers=> ", error);
    throw error;
  }
};

export const fetchPlanOffers = async (filters, TOKEN) => {
  let url = `plan/plan_offer`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchPlanOffers=> ", error);
    throw error;
  }
};

export const fetchOneDayPlans = async (filters, TOKEN) => {
  let url = `subscription?type=one_day_membership`;

  // Drop the caller's `type` key — this ODM endpoint is hardcoded to
  // type=one_day_membership. Previously both were appended, producing a
  // duplicate `type` query param which Express joined as "a,b" in the
  // backend SQL and broke the filter (returned 0 rows + 500 errors).
  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "" && key !== "type")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `&${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchOneDayPlans=> ", error);
    throw error;
  }
};

export const fetchODMStats = async (filters, TOKEN) => {
  let url = `subscription/one_day_membership_lead/stats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchODMStats=> ", error);
    throw error;
  }
};

export const fetchMemberSubscription = async (filters, TOKEN) => {
  let url = `subscription/member`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchMemberSubscription=> ", error);
    throw error;
  }
};

// PT (addon_pt) membership upgrade — ported from main
export const fetchUpgradePtMemberships = async (filters, TOKEN) => {
  let url = `subscription/upgrade_pt_membership`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchUpgradePtMemberships=> ", error);
    throw error;
  }
};

export const fetchPtUpgradeAddons = async (filters, TOKEN) => {
  let url = `subscription/upgrade_pt_membership/addons`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchPtUpgradeAddons=> ", error);
    throw error;
  }
};

export const fetchTestingNumbers = async (filters, TOKEN) => {
  let url = `gym/testing-number`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchTestingNumbers=> ", error);
    throw error;
  }
};

export const fetchUpgradeMemberships = async (filters, TOKEN) => {
  let url = `subscription/upgrade_membership`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchUpgradeMemberships=> ", error);
    throw error;
  }
};

export const fetchBiomaxRegisteredMembers = async (filters, TOKEN) => {
  let url = `subscription/subs_biomax_info`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchBiomaxRegisteredMembers=> ", error);
    throw error;
  }
};

export const fetchAllAccessPlans = async (filters, TOKEN) => {
  let url = `plan/allaccess_category`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchAllAccessPlans=> ", error);
    throw error;
  }
};

export const fetchRecurringSubscriptions = async (filters, TOKEN) => {
  let url = `subscription/tripple-nine`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchRecurringSubscriptions=> ", error);
    throw error;
  }
};

export const fetchRecurringSubscriptionStats = async (filters, TOKEN) => {
  let url = `subscription/tripple-nine/stats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchRecurringSubscriptionStats=> ", error);
    throw error;
  }
};

export const fetchWebsiteTabPrefence = async (filters, TOKEN) => {
  let url = `plan/tab-preferences`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchWebsiteTabPrefence=> ", error);
    throw error;
  }
};

export const fetchCentralisedPlans = async (filters, TOKEN) => {
  let url = `plan/draft/all?is_goal=0`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `&${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchCentralisedPlans=> ", error);
    throw error;
  }
};

export const fetchCentralisedPlanCategories = async (filters, TOKEN) => {
  let url = `gym/category`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchCentralisedPlanCategories=> ", error);
    throw error;
  }
};

export const fetchAllAddonDrafts = async (filters, TOKEN) => {
  let url = `addon/draft/getall`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchAllAddonDrafts=> ", error);
    throw error;
  }
};

export const fetchAllPlanPause = async (filters, TOKEN) => {
  let url = `pause/get-pause-settings`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchAllPlanPause=> ", error);
    throw error;
  }
};

export const fetchMembershipPause = async (filters, TOKEN) => {
  let url = `pause/pause-history`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchMembershipPause=> ", error);
    throw error;
  }
};

export const fetchOfferAttributes = async (filters, TOKEN) => {
  let url = `offer/attribute`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchOfferAttributes=> ", error);
    throw error;
  }
};

export const fetchTriggers = async (filters, TOKEN) => {
  let url = `offer/ren_unp_offer`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchTriggers=> ", error);
    throw error;
  }
};

export const fetchTriggersDays = async (filters, TOKEN) => {
  let url = `offer/ren_unp_offer/days_details`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchTriggersDays=> ", error);
    throw error;
  }
};

export const fetchInventories = async (filters, TOKEN) => {
  let url = `offer/goodies`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchInventories=> ", error);
    throw error;
  }
};

export const fetchPlans = async (filters, TOKEN) => {
  let url = `plan`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchPlans=> ", error);
    throw error;
  }
};

export const fetchThreeDayPTTrial = async (filters, TOKEN) => {
  let url = `ptTrial/three_day_members`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchThreeDayPTTrial=> ", error);
    throw error;
  }
};

export const fetchMemberTrialHistory = async (filters, TOKEN) => {
  let url = `ptTrial/three_day/history`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchMemberTrialHistory=> ", error);
    throw error;
  }
};

export const fetchSubscriptionExtensionRequests = async (filters, TOKEN) => {
  let url = `subscription/extension-requests`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchSubscriptionExtensionRequests=> ", error);
    throw error;
  }
};

export const fetchManualExtensionData = async (filters, TOKEN) => {
  let url = `subscription/extend-days`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchManualExtensionData=> ", error);
    throw error;
  }
};

export const fetchMemberDetailsByMobile = async (mobile, TOKEN) => {
  let url = `user?mobile=${mobile}`;

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchMemberDetailsByMobile=> ", error);
    throw error;
  }
};

export const fetchTrialSessionDetails = async (filters, TOKEN) => {
  let url = `ptTrial/session_details`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchTrialSessionDetails=> ", error);
    throw error;
  }
};

export const fetchMemberDietStatsData = async (filters, TOKEN) => {
  let url = `dietmapping/stats/avg`;

  const filteredParams = Object.entries(filters || {})
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchMemberDietStatsData=> ", error);
    throw error;
  }
};

export const fetchMemberTmeDietStatsData = async (filters, TOKEN) => {
  let url = `dietmapping/diet/tme-stats`;

  const filteredParams = Object.entries(filters || {})
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchMemberTmeDietStatsData=> ", error);
    throw error;
  }
};

export const fetchNutritionLogs14DaysData = async (filters, TOKEN) => {
  let url = `dietmapping/diet/tme-detailed-view`;

  const filteredParams = Object.entries(filters || {})
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchNutritionLogs14DaysData=> ", error);
    throw error;
  }
};

export const fetchTrainerPTRenewals = async (filters, TOKEN) => {
  let url = `trainer/renewal_members_details`;

  const filteredParams = Object.entries(filters || {})
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTrainerPTRenewals=> ", error);
    throw error;
  }
};

export const fetchPaymentLinkHomeStat = async (filters, TOKEN) => {
  let url = `subscription/draftorder/payment-link/volume`;

  const filteredParams = Object.entries(filters || {})
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchPaymentLinkHomeStat=> ", error);
    throw error;
  }
};

// Three Day PT Trial - Member Details
export const fetchThreeDayPTMemberDetails = async (filters, TOKEN) => {
  let url = `ptTrial/threeday/member-details`;

  const filteredParams = Object.entries(filters || {})
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchThreeDayPTMemberDetails=> ", error);
    throw error;
  }
};

// Three Day PT Trial - Session Stats
export const fetchThreeDayPTSessionStats = async (filters, TOKEN) => {
  let url = `ptTrial/threeday/session-stats`;

  const filteredParams = Object.entries(filters || {})
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchThreeDayPTSessionStats=> ", error);
    throw error;
  }
};

export const fetchThreeDayPTMembersStats = async (filters, TOKEN) => {
  const queryParams = new URLSearchParams(filters).toString();
  const url = `ptTrial/three_day_members/stats${
    queryParams ? `?${queryParams}` : ""
  }`;

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchThreeDayPTMembersStats=> ", error);
    throw error;
  }
};

export const fetchAddonCategories = async (filters, TOKEN) => {
  let url = `addoncat?is_web=1`;

  const filteredParams = Object.entries(filters || {})
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `&${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAddonCategories=> ", error);
    throw error;
  }
};

export const fetchAddonCarryItems = async (filters, TOKEN) => {
  let url = `addon/carryitems`;

  const filteredParams = Object.entries(filters || {})
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAddonCarryItems=> ", error);
    throw error;
  }
};

export const fetchAddonBenefits = async (filters, TOKEN) => {
  let url = `addoncat/benefits`;

  const filteredParams = Object.entries(filters || {})
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAddonBenefits=> ", error);
    throw error;
  }
};

// 3-Day PT Trial — Trainer Trial Report (ported from main). Read-only.
export const fetchTrainerTrialReport = async (filters, TOKEN) => {
  let url = `ptTrial/threeday/trainer-report`;
  const filteredParams = Object.entries(filters || {})
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
  if (filteredParams) {
    url += `?${filteredParams}`;
  }
  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: { Authorization: `Bearer ${TOKEN}` },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTrainerTrialReport=> ", error);
    throw error;
  }
};

// 3-Day PT Trial — Trainer Trial Report drill-down (users behind a number). Read-only.
export const fetchTrainerTrialReportUsers = async (filters, TOKEN) => {
  let url = `ptTrial/threeday/trainer-report/users`;
  const filteredParams = Object.entries(filters || {})
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
  if (filteredParams) {
    url += `?${filteredParams}`;
  }
  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: { Authorization: `Bearer ${TOKEN}` },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTrainerTrialReportUsers=> ", error);
    throw error;
  }
};
